import React, { useState, useEffect, useMemo } from "react";
import PlantillaScreen3 from "../../helpers/PlantillaScreen3";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { LoaderScreen } from "../../components/LoaderScreen";
import { CheckIcon, ChevronDown, FilterIcon, SearchIcon, SendIcon, SettingsIcon2, XIcon } from "../Helper/Icons";
import { DetalleModal } from "./DetalleModal";
import { useLocation } from "react-router-dom";
import TimelineJustificacionesModal from "./TimelineJustificacionModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import TimelineIcon from '@mui/icons-material/Timeline';
import { RealizarConteoHeader } from "../ConteosAuditoria/RealizarConteoHeader";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { RealizarConteoHeaderModal } from "../ConteosAuditoria/RealizarConteoHeaderModal";


// ── Config estatus justificación ──────────────────────────────────────────────
const JUST_CONFIG = {
    P: { label: "Pendiente", dot: "#8d9688", bg: "#eef0ec", text: "#4f5a4b", border: "#d5d9d0" },
    J: { label: "Justificado", dot: "#0891b2", bg: "#e0f7fa", text: "#065f70", border: "#67d4e8" },
    A: { label: "Aceptado", dot: "#639922", bg: "#eaf3de", text: "#27500a", border: "#97c459" },
    X: { label: "Revisión", dot: "#d97706", bg: "#fff8e1", text: "#7c4a00", border: "#fbbf24" }, // ámbar — aceptación parcial
    R: { label: "Rechazado", dot: "#e24b4a", bg: "#fcebeb", text: "#791f1f", border: "#f09595" },
};

const FILTROS = [
    { value: "todos", label: "Todos" },
    { value: "P", label: "Pendientes" },
    { value: "J", label: "Justificados" },
    { value: "A", label: "Aceptados" },
    { value: "X", label: "Revisión" }, // ← agregar
    { value: "R", label: "Rechazados" },
];


// ── Componente principal ──────────────────────────────────────────────────────
export const JustificacionMainScreen = () => {
    const location = useLocation();
    const history = useHistory();

    const { roles } = useSelector((state) => state.sesion);
    const { idempleado } = useSelector((state) => state.usuario);

    const rolesAuditor = ["REWR", "AAUD", 'AUDI'];

    const esAuditor = roles.some(r => rolesAuditor.includes(r.idrol));

    const folio = location.state?.folio;

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [items, setItems] = useState([]);
    const [infoHeader, setInfoHeader] = useState(null);
    const [itemActivo, setItemActivo] = useState(null);
    const [search, setSearch] = useState("");
    const [filtro, setFiltro] = useState("todos");
    const [openFiltro, setOpenFiltro] = useState(false);
    const [openOptions, setOpenOptions] = useState(null);
    const [openHeaderModal, setOpenHeaderModal] = useState(false);
    const [esEncargado, setEsEncargado] = useState(true);



    //state para abrir timeline
    const [idConteo, setIdConteo] = useState(null);
    const [openTimeline, setOpenTimeline] = useState(false);
    const [diferenciasTimeline, setDiferenciasTimeline] = useState(0);


    // Cargar discrepancias
    useEffect(() => {
        if (!folio) return;
        setLoading(true);
        request
            .get(`AuditoriaJustificaciones/Listado?folio=${folio}`)
            .then(async (result) => {
                setLoading(false);
                setItems(result.listado)
                setInfoHeader(result.header)

                if (result.header.id_responsable_alm === Number(idempleado)) {
                    setEsEncargado(true)
                }
            })
            // .then(result => setItems(result.items ?? []))
            .catch(err => Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"))
            .finally(() => setLoading(false));
    }, [folio]);

    // Filtros + búsqueda
    const itemsFiltrados = useMemo(() => {
        return items
            .filter(it => filtro === "todos" || it.estatus_just === filtro)
            .filter(it =>
                !search ||
                it.modelo?.toLowerCase().includes(search.toLowerCase()) ||
                it.descripcion?.toLowerCase().includes(search.toLowerCase()) ||
                it.categoria?.toLowerCase().includes(search.toLowerCase())
            );
    }, [items, filtro, search]);

    // Contadores para el resumen
    const contadores = useMemo(() => ({
        total: items.length,
        pendientes: items.filter(i => i.estatus_just === "P").length,
        justificados: items.filter(i => i.estatus_just === "J").length,
        aceptados: items.filter(i => i.estatus_just === "A").length,
        parciales: items.filter(i => i.estatus_just === "X").length, // ← agregar
        rechazados: items.filter(i => i.estatus_just === "R").length,
    }), [items]);

    // Guardar justificación (usuario)
    const handleGuardar = ({ idconteo, idjust, comentario, archivos }) => {
        // setSaving(true);
        const form = new FormData();
        form.append("folio", folio);
        form.append("idconteo", idconteo);
        form.append("idjust", idjust);
        form.append("comentario", comentario);
        archivos.forEach(f => form.append("archivos", f));

        request.postForm("AuditoriaJustificaciones/Guardar", form)
            .then(async result => {
                setSaving(false);
                if (result.resultado === 1) {
                    await Swal.fire("JUSTIFICACIONES", result.mensaje, "error");
                } else {
                    await Swal.fire("JUSTIFICACIONES", "Justificación guardada con éxito", "success");
                    setItemActivo(null);
                    recargar();
                }
            })
            .catch(err => { setSaving(false); Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"); });
    };

    // Aceptar (auditor)
    const handleAceptar = ({ folio, idjust, tipo_aceptacion, cantidad_aceptada }) => {
        const post = {
            folio,
            idjust,
            tipo_aceptacion,
            cantidad_aceptada
        }
        setSaving(true);
        request.post("AuditoriaJustificaciones/Aceptar", post)
            .then(async result => {
                setSaving(false);
                if (result.resultado === 1) {
                    await Swal.fire("JUSTIFICACIONES", result.mensaje, "error");
                } else {
                    await Swal.fire("JUSTIFICACIONES", "Justificación aceptada", "success");
                    setItemActivo(null);
                    recargar();
                }
            })
            .catch(err => { setSaving(false); Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"); });
    };

    // Rechazar (auditor)
    const handleRechazar = ({ folio, idjust, motivo }) => {
        const post = {
            folio,
            idjust,
            motivo
        }
        setSaving(true);
        request.post("AuditoriaJustificaciones/Rechazar", post)
            .then(async result => {
                setSaving(false);
                if (result.resultado === 1) {
                    await Swal.fire("JUSTIFICACIONES", result.mensaje, "error");
                } else {
                    await Swal.fire("JUSTIFICACIONES", "Justificación rechazada", "success");
                    setItemActivo(null);
                    recargar();
                }
            })
            .catch(err => { setSaving(false); Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"); });
    };

    const recargar = () => {
        setLoading(true);
        request
            .get(`AuditoriaJustificaciones/Listado?folio=${folio}`)
            .then(async (result) => {
                setLoading(false);
                setItems(result.listado)
            })
            // .then(result => setItems(result.items ?? []))
            .catch(err => Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"))
            .finally(() => setLoading(false));
    };

    const onRegresar = () => {

        history.push('/Auditoria/Justificaciones');
    };

    // Encargado almacén → notifica al auditor que ya justificó todo
    const handleEnviarRevisionAuditor = async () => {
        // const { isConfirmed } = await Swal.fire({
        //     title: "¿Enviar a revisión?",
        //     text: "Se notificará al auditor que todas las piezas han sido justificadas.",
        //     icon: "question",
        //     showCancelButton: true,
        //     confirmButtonText: "Sí, enviar",
        //     cancelButtonText: "Cancelar",
        //     confirmButtonColor: "#367c2b",
        // });
        // if (!isConfirmed) return;

        setSaving(true);
        request.post("AuditoriaJustificaciones/EnviarRevisionAlmacen", { folio })
            .then(async result => {
                setSaving(false);
                if (result.resultado === 1) {
                    await Swal.fire("JUSTIFICACIONES", result.mensaje, "error");
                } else {
                    await Swal.fire("JUSTIFICACIONES", "Enviado a revisión con éxito", "success");
                    recargar();
                }
            })
            .catch(err => { setSaving(false); Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"); });
    };

    // Auditor → cierra la revisión y finaliza el proceso
    const handleEnviarRevisionFinal = async () => {
        // const { isConfirmed } = await Swal.fire({
        //     title: "¿Finalizar revisión?",
        //     text: "Se marcará el inventario como revisado. Esta acción no se puede deshacer.",
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonText: "Sí, finalizar",
        //     cancelButtonText: "Cancelar",
        //     confirmButtonColor: "#367c2b",
        // });
        // if (!isConfirmed) return;

        setSaving(true);
        request.post("AuditoriaJustificaciones/EnviarRevisionAuditor", { folio })
            .then(async result => {
                setSaving(false);
                if (result.resultado === 1) {
                    await Swal.fire("JUSTIFICACIONES", result.mensaje, "error");
                } else {
                    await Swal.fire("JUSTIFICACIONES", "Revisión finalizada con éxito", "success");
                    recargar();
                }
            })
            .catch(err => { setSaving(false); Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"); });
    };

    return (
        <PlantillaScreen3 titulo="JUSTIFICACIÓN DE DISCREPANCIAS" className="jd-root">
            <LoaderScreen loader={loading || saving} />


            <div className="justificacion-auditoria-actions">
                <div
                    className="justificacion-auditoria-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>


            {/* ── Resumen ── */}
            <div className="jd-summary">
                {[
                    { label: "Total", value: contadores.total, mod: "" },
                    { label: "Pendientes", value: contadores.pendientes, mod: "--pending" },
                    { label: "Justificados", value: contadores.justificados, mod: "--info" },
                    { label: "Aceptados", value: contadores.aceptados, mod: "--ok" },
                    { label: "Parciales", value: contadores.parciales, mod: "--partial" }, // ← agregar
                    { label: "Rechazados", value: contadores.rechazados, mod: "--danger" },
                ].map(s => (
                    <div key={s.label} className={`jd-summary-card jd-summary-card${s.mod}`}>
                        <span className="jd-summary-card__value">{s.value}</span>
                        <span className="jd-summary-card__label">{s.label}</span>
                    </div>
                ))}
            </div>

            {/* ── Barra de herramientas ── */}
            <div className="jd-toolbar">
                <button
                    className="pa-btn pa-btn--icon"
                    onClick={() => setOpenHeaderModal(true)}
                    title="Ver resumen de auditoría"
                >
                    <VisibilityIcon />
                </button>

                <div className="jd-search">
                    <SearchIcon />
                    <input
                        type="text"
                        className="jd-search__input"
                        placeholder="Buscar por modelo, descripción o categoría..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    {search && (
                        <button type="button" className="jd-search__clear" onClick={() => setSearch("")}>
                            <XIcon />
                        </button>
                    )}
                </div>

                {/* Filtro de estatus */}
                <div className={`jd-filter-select ${openFiltro ? "open" : ""}`}>
                    <button
                        type="button"
                        className="jd-filter-select__trigger"
                        onClick={() => setOpenFiltro(o => !o)}
                    >
                        <FilterIcon />
                        {FILTROS.find(f => f.value === filtro)?.label}
                        <ChevronDown />
                    </button>
                    {openFiltro && (
                        <div className="jd-filter-select__dropdown">
                            {FILTROS.map(f => (
                                <div
                                    key={f.value}
                                    className={`jd-filter-select__option ${filtro === f.value ? "selected" : ""}`}
                                    onClick={() => { setFiltro(f.value); setOpenFiltro(false); }}
                                >
                                    {f.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ── Botón encargado almacén — enviar a revisión del auditor ── */}
                {esEncargado && !esAuditor && contadores.pendientes === 0 && contadores.total > 0 && (
                    <button
                        type="button"
                        className="jd-btn jd-btn--primary"
                        onClick={handleEnviarRevisionAuditor}
                        disabled={saving}
                    >
                        {saving ? <span className="jd-btn__spinner" /> : <SendIcon />}
                        Enviar a revisión
                    </button>
                )}

                {/* ── Botón auditor — enviar a revisión final / autorizar ── */}
                {esAuditor && contadores.pendientes === 0 && contadores.total > 0 && (
                    <button
                        type="button"
                        className="jd-btn jd-btn--accept"
                        onClick={handleEnviarRevisionFinal}
                        disabled={saving}
                    >
                        {saving ? <span className="jd-btn__spinner" /> : <SendIcon />}
                        Enviar revisión
                    </button>
                )}
            </div>

            {/* ── Lista de ítems ── */}
            <div className="jd-list-view">

                {/* Header */}
                <div className="jd-list-header">
                    <div className="jd-list-header__modelo ta-center">Modelo / Descripción</div>
                    <div className="jd-list-header__cat borde-izq">Categoría</div>
                    <div className="jd-list-header__num borde-izq ta-center">Sistema</div>
                    <div className="jd-list-header__num borde-izq ta-center">Físico</div>
                    <div className="jd-list-header__num borde-izq ta-center">Diferencia</div>
                    <div className="jd-list-header__estatus borde-izq ta-center">Estatus</div>
                    <div className="jd-list-header__actions" />
                    <div className="jd-list-header__actions" />
                </div>

                {loading ? null : itemsFiltrados.length === 0 ? (
                    <div className="jd-list-empty">
                        {search || filtro !== "todos"
                            ? "Sin resultados para los filtros aplicados."
                            : "Sin discrepancias registradas para este inventario."}
                    </div>
                ) : (
                    itemsFiltrados.map((item, idx) => {
                        const cfg = JUST_CONFIG[item.estatus_just] ?? JUST_CONFIG["P"];
                        const diff = item.diferencia;

                        return (
                            <div
                                key={item.iddetalle ?? idx}
                                className="jd-list-row"
                            // onClick={() => setItemActivo(item)}
                            >
                                {/* Indicador lateral de estatus */}
                                <div
                                    className="jd-list-row__indicator"
                                    style={{ background: cfg.dot }}
                                />

                                {/* Modelo + descripción */}
                                <div className="jd-list-row__modelo">
                                    <span className="jd-list-row__modelo-id">{item.modelo}</span>
                                    <span className="jd-list-row__modelo-desc">{item.descripcion}</span>
                                </div>

                                {/* Categoría */}
                                <div className="jd-list-row__cat ta-center">{item.categoria}</div>

                                {/* Cantidades */}
                                <div className="jd-list-row__num ta-right">{item.cant_sistema}</div>
                                <div className="jd-list-row__num ta-right">{item.cant_fisica}</div>
                                <div className={`jd-list-row__num jd-list-row__num--diff ta-right ${diff > 0 ? "pos" : "neg"}`}>
                                    {diff > 0 ? `+${diff}` : diff}
                                </div>

                                {/* Badge estatus */}
                                <div className="jd-list-row__estatus">
                                    <span
                                        className="jd-badge"
                                        style={{ background: cfg.bg, color: cfg.text, borderColor: cfg.border }}
                                    >
                                        <span className="jd-badge__dot" style={{ background: cfg.dot }} />
                                        {cfg.label}
                                    </span>
                                </div>

                                {/* Acciones rápidas */}
                                <div
                                    className="jd-list-row__actions"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <button
                                        type="button"
                                        className="jd-action-btn"
                                        title="Ver detalle"
                                        onClick={() => setItemActivo(infoHeader.habilitar === false ? null : item)}
                                    >
                                        <SettingsIcon2 />
                                    </button>
                                </div>
                                <div
                                    className="jd-list-row__actions"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <button
                                        type="button"
                                        className="jd-action-btn"
                                        title="Ver Timeline"
                                        onClick={() => {
                                            setIdConteo(item);
                                            setOpenTimeline(true);
                                            setDiferenciasTimeline(item.diferencia)
                                        }}
                                    >
                                        <TimelineIcon />
                                    </button>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            {/* ── Modal de detalle ── */}
            {itemActivo && (
                <DetalleModal
                    item={itemActivo}
                    onClose={() => setItemActivo(null)}
                    onGuardar={handleGuardar}
                    onAceptar={handleAceptar}
                    onRechazar={handleRechazar}
                    esAuditor={esAuditor}//esAuditor
                    esEncargado={esEncargado}
                    loading={saving}
                />
            )}

            {openTimeline && (
                <TimelineJustificacionesModal
                    item={idConteo}
                    onClose={() => setOpenTimeline(false)}
                    open={openTimeline}
                    diferencias={diferenciasTimeline}
                />
            )}

            <RealizarConteoHeaderModal
                open={openHeaderModal}
                onClose={() => setOpenHeaderModal(false)}
                info={infoHeader}
            />
        </PlantillaScreen3>

    );
};

export default JustificacionMainScreen;
